import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes2';
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from,next) => {
    let routerlists = sessionStorage.getItem('routeslists');
    //返回受权限控制的所有路由路径
    let menu_path_all = sessionStorage.getItem('menu_path_all');
    if(menu_path_all){
        menu_path_all = JSON.parse(menu_path_all); //转JSON对象
        //判断当前路由是否在受权限控制路由数组之内
        if(menu_path_all.includes(to.fullPath)){
            routerlists = JSON.parse(routerlists);
            let routerlist_path = [];
            //权限path提取出来 
            routerlists.map((item) =>{
                routerlist_path.push(item.path);
                if(item.children){
                    item.children.map((chid_item)=>{
                        routerlist_path.push(chid_item.path);
                    })
                }
            })
           //验证当前路由是否具备权限 
            if(routerlist_path.includes(to.fullPath)){
               
            }else{
                console.log('非法访问');
            }
        }

    }
    next();
})
export default router
